import styled from 'styled-components'

export const NoAssetsTableRow = styled.p`
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 140%;
  color: ${(p) => p.theme.colors.primaryDefault};
  text-align: center;
  padding: 0 10px;
`
